<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="twinstar-logo"
  >
    <template v-if="monochrome">
      <circle cx="50" cy="50" r="36" stroke="currentColor" stroke-width="1.5" stroke-dasharray="4 8" opacity=".4" />
      <path d="M 25 25 C 40 10, 60 10, 75 25 C 90 40, 90 60, 75 75 C 60 90, 40 90, 25 75 Z" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" opacity=".8" />
      <path d="M 25 25 C 10 40, 10 60, 25 75 C 40 90, 60 90, 75 75 C 90 60, 90 40, 75 25 Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" opacity=".5" stroke-dasharray="16 8" />
      <circle cx="25" cy="25" r="7" fill="currentColor" /><circle cx="25" cy="25" r="2.5" fill="var(--twinstar-mono-bg, #fff)" />
      <circle cx="75" cy="75" r="7" fill="currentColor" /><circle cx="75" cy="75" r="2.5" fill="var(--twinstar-mono-bg, #fff)" />
      <path d="M 50 18 Q 50 50 18 50 Q 50 50 50 82 Q 50 50 82 50 Q 50 50 50 18 Z" fill="currentColor" />
      <circle cx="50" cy="50" r="2" fill="var(--twinstar-mono-bg, #fff)" />
    </template>
    <template v-else>
      <defs>
        <linearGradient :id="uid + '-gl'" x1="15" y1="15" x2="45" y2="45" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stop-color="#38bdf8" /><stop offset="50%" stop-color="#2563eb" /><stop offset="100%" stop-color="#7c3aed" />
        </linearGradient>
        <linearGradient :id="uid + '-gr'" x1="85" y1="85" x2="55" y2="55" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stop-color="#ec4899" /><stop offset="50%" stop-color="#8b5cf6" /><stop offset="100%" stop-color="#3b82f6" />
        </linearGradient>
        <linearGradient :id="uid + '-star'" x1="50" y1="15" x2="50" y2="85" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stop-color="#ffffff" /><stop offset="40%" stop-color="#a5f3fc" /><stop offset="100%" stop-color="#3b82f6" />
        </linearGradient>
        <filter :id="uid + '-glow'" x="-20%" y="-20%" width="140%" height="140%" filterUnits="userSpaceOnUse">
          <feGaussianBlur stdDeviation="5" result="blur" />
          <feComposite in="SourceGraphic" in2="blur" operator="over" />
        </filter>
      </defs>
      <circle cx="50" cy="50" r="36" :stroke="`url(#${uid}-gl)`" stroke-width="1.5" stroke-dasharray="4 8" opacity=".4" />
      <path d="M 25 25 C 40 10, 60 10, 75 25 C 90 40, 90 60, 75 75 C 60 90, 40 90, 25 75 Z" :stroke="`url(#${uid}-gr)`" stroke-width="2.5" stroke-linecap="round" opacity=".85" />
      <path d="M 25 25 C 10 40, 10 60, 25 75 C 40 90, 60 90, 75 75 C 90 60, 90 40, 75 25 Z" :stroke="`url(#${uid}-gl)`" stroke-width="1.5" stroke-linecap="round" opacity=".6" stroke-dasharray="16 8" />
      <g :filter="`url(#${uid}-glow)`">
        <circle cx="25" cy="25" r="8" :fill="`url(#${uid}-gl)`" /><circle cx="25" cy="25" r="3" fill="#ffffff" />
      </g>
      <g :filter="`url(#${uid}-glow)`">
        <circle cx="75" cy="75" r="8" :fill="`url(#${uid}-gr)`" /><circle cx="75" cy="75" r="3" fill="#ffffff" />
      </g>
      <path d="M 50 18 Q 50 50 18 50 Q 50 50 50 82 Q 50 50 82 50 Q 50 50 50 18 Z" :fill="`url(#${uid}-star)`" :filter="`url(#${uid}-glow)`" />
      <circle cx="50" cy="50" r="2" fill="#ffffff" />
    </template>
  </svg>
</template>

<script setup>
import { computed } from 'vue'

/**
 * TwinStar 双子星品牌 Logo
 *
 * 全彩版：蓝→靛→紫渐变双子节点 + 白色北极星，适配深色背景
 * 单色版：currentColor 描边填充，适配任意底色（浅底用深色文字色）
 *
 * 多实例安全：渐变/滤镜 id 以组件实例 uid 前缀隔离，避免同页多 Logo 时 SVG defs id 冲突
 */
const props = defineProps({
  size: { type: [Number, String], default: 40 },
  monochrome: { type: Boolean, default: false },
})

let seq = 0
const uid = computed(() => `ts${++seq}-${Math.random().toString(36).slice(2, 7)}`)
</script>

<style scoped>
.twinstar-logo {
  display: block;
  flex-shrink: 0;
}
</style>
